export default __webpack_public_path__ + "static/media/step5.5d0643d1.svg";